import React, { useRef, useEffect, useState } from "react";

import { Link } from 'react-router-dom';
import AuthService from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import { useHistory } from 'react-router-dom';


import InputBox from "../components/InputBox";
import { Outlet } from "react-router-dom";
import logo0 from "../assets/img/logo0.png";


//--- CONTEXT API -----------
import { useStore, useDispatch } from "store/StoreProvider";
import { types } from "store/StoreReducer";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
 //---------------- CONTEXT API ------------------
    const store = useStore();
    const dispatch = useDispatch();

    const {user, products} = store;

    const [modalShow, setModalShow] = useState(false);
    const [input, setInput] = useState("");

    const [modalShow1, setModalShow1] = useState(false);
    const [input1, setInput1] = useState("");

    const navigate = useNavigate();
    
    //--------------para el timer---
    const [expirationDate, setExpirationDate] = useState("");
    let timer = useRef(null);
    let i=0;
    
    //-----------------------------------
    const logout=(e)=>{
        e.preventDefault();
        //console.log("aqui estoy");
        AuthService.logout();
        navigate("/login");
        //let history = useHistory();
        //history.push("/login");
    }
    //---------- NUEVO ------------------
    //----------------INPUTBOX EDITAR (1) ---------------------
    const editar=(e)=>{
        e.preventDefault();
        setModalShow1(true);
    }
    const handleOK1=()=>{ 
        setModalShow1(false);  
        
        let fileURL = "/certificado1/"+ input1+"/e";
        //navigate(fileURL);
        window.location= fileURL;
    }
    const handleCancel1=()=>{ setModalShow1(false);   }
    const handleChange1=(e)=>{setInput1(e.target.value);  }
    //------------------INPUTBOX--REIMPRIME () ------------------------
    const reimprimir=(e)=>{
        e.preventDefault();
        setModalShow(true);
    }
    
    const handleOK=()=>{ 
        setModalShow(false);   
        let fileURL = process.env.REACT_APP_API_URL + "certificado_reciboPDF/"+ input;
        let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
        window.open(fileURL,'',windowFeatures);
    }
    const handleCancel=()=>{ setModalShow(false);   }
    const handleChange=(e)=>{setInput(e.target.value);  }
    const toogleMenu=()=>{
      console.log("toogleMenu")
      //--apuntamos al body
      let element = document.getElementsByTagName("BODY")[0];
      element.classList.toggle("sidebar-collapse");
    }
    //-----------------------------------------------------------
    return (
      <div>
        <div className="" style={{ minHeight: 674 }}>

          {/* barra de navegacion */}
          <nav className="navbar navbar-expand navbar-dark bg-dark1 border-bottom pad5">
            <Link to="/panel" className="navbar-brand">
              <i className="fa fa-fw fa-rocket" style={{ color: 'orange'}}></i>
              <span>Educo.</span>
            </Link>
            
            <button className="navbar-toggler" type="button" 
                    data-toggle="collapse" data-target="#demo-navbar" 
                    aria-controls="demo-navbar" aria-expanded="false" 
                    aria-label="Toggle navigation" onClick={()=> toogleMenu() }>
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="demo-navbar">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <Link className="nav-link text-light" to="/panel" >
                    <i className="fa fa-home" ></i> Menú
                  </Link> 
                </li>
                
              </ul>

              <li className="nav-item">
                <span style={{ color:'white'}}>Rol:</span>
                <span style={{color:'orange'}}>  {user.rol_nom } </span>
                
              </li>
              <li className="nav-item">
              <span style={{ color:'white'}}>Periodo:</span>
                <span style={{color:'orange'}}>  {user.periodo } </span>
              </li>

              <ul className="app-nav">
              
                <li className="dropdown">
                  <button className="app-nav__item" href="#" data-bs-toggle="dropdown"
                      aria-label="Open Profile Menu" aria-expanded="false">
                    <i className="fa fa-user fa-lg"></i> &nbsp;ADMIN                
                  </button>
                  
                  <ul className="dropdown-menu settings-menu dropdown-menu-right" 
                      x-placement="bottom-end" style={{ position: 'absolute', willChange: 'transform', top: '0px', 
                                              left:'0px', transform: 'translate3d(-117px, 50px, 0px)'}}>
                    {/*<li><Link className="dropdown-item" to="/config"><i className="fa fa-cog fa-lg"></i> Config</Link></li>
                    <li><Link className="dropdown-item" to="/perfil"><i className="fa fa-user fa-lg"></i> Perfil</Link></li>
                    <Link to="/cambiarclave" className="dropdown-item">
                      <i className="fa fa-key"></i> Cambiar clave
                    </Link>*/}
                    <button className="dropdown-item" onClick={logout} >Cerrar sesión</button>
                  </ul>
                </li>
              </ul>


            </div>
          </nav>

          {/* <!-- /.content-header --> */}
          <div className="containerxx">
            {/*<!--Contenido-->*/}
            <Outlet />
          </div>
        </div>

        

      </div>
    )
}